import * as React from "react";
import { useProvider } from "../../Context";

const initialState = {
  token: null,
  user: {},
};

function reducer(state, { type, payload }) {
  switch (type) {
    case "set":
      return { ...state, ...payload };
    case "setTokenResult":
      return { ...state, token: payload };
    case "setUser":
      return { ...state, user: payload };
    default:
      throw new Error("Action type not found");
  }
}

export function useAuthReducer() {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  return {
    state,
    dispatch,
  };
}

export default function () {
  const {
    auth: { state, dispatch },
  } = useProvider();

  function login({ token, user }) {
    localStorage.setItem("uploadtoken", token);
    localStorage.setItem("uploaduser", JSON.stringify(user));
    dispatch({ type: "set", payload: { token, user } });
  }

  function logout() {
    localStorage.clear();
    dispatch({
      type: "set",
      payload: { 
        token: null,
        user: {},
      },
    });
  }

  return {
    state: state,
    dispatch: dispatch,
    login,
    logout,
  };
}
